<template>
  <router-view />
</template>

<script>
export default {
name: "UserMain",
}
</script>

<style>

</style>